import React from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '../ui/SectionHeader';
import Reveal from '../ui/Reveal';
import Icon from '../ui/Icon';
import { SERVICES } from '../../data/site';

export default function ServicesPreview() {
  // Hover-follow glow — track pointer position per card and pipe it into a CSS var.
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
    e.currentTarget.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
  };

  return (
    <section className="section" id="services">
      <div className="container">
        <SectionHeader
          eyebrow="Services / 01"
          title="Six focused practices, one accountable team."
          lede="We work as embedded partners — strategy, design, and engineering under one roof so the handoffs disappear and the build stays sharp."
        />

        <Reveal>
          <div className="svc-grid">
            {SERVICES.map((s, i) => (
              <Link key={s.slug} to={`/services#${s.slug}`} className="svc" onMouseMove={onMove}>
                <div className="svc__num">{String(i + 1).padStart(2, '0')} ·</div>
                <div className="svc__icon"><Icon name={s.icon} size={20} /></div>
                <div className="svc__title">{s.title}</div>
                <div className="svc__desc">{s.short}</div>
                <div className="svc__arrow">
                  Learn more <Icon name="arrow" size={11} />
                </div>
              </Link>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
